import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router';

import FeedPage from '@/pages/FeedView.vue';
import HelpPage from '@/pages/HelpView.vue';
import LoginPage from '@/pages/LoginView.vue';
import NoConnectionPage from '@/pages/NoConnectionView.vue';
import NotFoundPage from '@/pages/NotFoundView.vue';
import PrivacyPage from '@/pages/PrivacyView.vue';
import PrivacyPolicyPage from '@/pages/PrivacyPolicyView.vue';
import ChildAllTasksPage from '@/pages/child/AllTasksView.vue';
import ChildAvgHelpPage from '@/pages/child/AvgHelpView.vue';
import ChildCalendarPage from '@/pages/child/CalendarView.vue';
import ChildMenuPage from '@/pages/child/MenuView.vue';
import ChildGradesRatingPage from '@/pages/child/GradesRatingView.vue';
import ChildReportCardPage from '@/pages/child/ReportCardView.vue';
import ChildCareerGuidePage from '@/pages/child/CareerGuideView.vue';
import ChildSchedulePage from '@/pages/child/ScheduleView.vue';
import ChildSosPage from '@/pages/child/SosView.vue';
import ChildTaskPage from '@/pages/child/TaskView.vue';
import ChildTestPage from '@/pages/child/TestView.vue';
import ChildVideoCoursePage from '@/pages/child/VideoCourseView.vue';
import FeedNewsPage from '@/pages/feed/FeedNewsView.vue';
import HalykEasyPage from '@/pages/feed/HalykEasyView.vue';
import QuizProfiwayPage from '@/pages/feed/QuizProfiwayView.vue';
import QuizPage from '@/pages/feed/QuizView.vue';
import SettingsChangeLangPage from '@/pages/settings/SettingsChangeLangView.vue';
import SettingsChangePasswordPage from '@/pages/settings/SettingsChangePasswordView.vue';
import SettingsExitPage from '@/pages/settings/SettingsExitView.vue';
import SettingsPage from '@/pages/settings/SettingsView.vue';
import { useDeviceStore } from '@/stores/device';
import { useViewerStore } from '@/stores/viewer';

function subtopbarCommon() {
  return [
    { num: 0, icon: 'view_quilt', name: 'feed', to: '/feed' },
    { num: 1, icon: 'alarm', name: 'child-schedule', to: '/schedule' },
    { num: 2, icon: 'date_range', name: 'calendar', to: '/calendar' },
    { num: 3, icon: 'subject', name: 'child-grades-rating', to: '/grades-rating' },
    { num: 4, icon: 'equalizer', name: 'child-report-card', to: '/report-card' },
    { num: 5, icon: 'history_edu', name: 'all-tasks', to: '/all-tasks', menubarOnly: true },
    { num: 6, icon: 'restaurant_menu', name: 'menu', to: '/menu', menubarOnly: true },
    { num: 7, icon: 'smart_display', name: 'video-course', to: '/video-course', menubarOnly: true, only: 'child' },
    { num: 8, icon: 'business_center', name: 'career-guide', to: '/career-guide', menubarOnly: true },
    {
      num: 9,
      icon: 'notifications',
      name: 'sos',
      to: '/sos',
      menubarOnly: true,
      only: 'child',
      new: true,
      classAdd: 'bellSos'
    }
  ];
}

const routes = [
  { path: '/login', name: 'login', component: LoginPage, meta: { guestOnly: true } },
  { path: '/no-connection', name: 'no-connection', component: NoConnectionPage },
  { path: '/privacy', name: 'privacy', component: PrivacyPage },
  { path: '/privacy-policy', name: 'privacy-policy', component: PrivacyPolicyPage },
  { path: '/feed', name: 'feed', component: FeedPage, meta: { requiresAuth: true, subtopbar: subtopbarCommon } },
  {
    path: '/feed/:id',
    name: 'feed-news',
    component: FeedNewsPage,
    meta: { requiresAuth: true, subtopbar: subtopbarCommon, titleKey: 'feed' }
  },
  {
    path: '/halyk-easy',
    name: 'halyk-easy',
    component: HalykEasyPage,
    meta: { requiresAuth: true, subtopbar: subtopbarCommon, titleKey: 'back_button_label' }
  },
  {
    path: '/quiz/:quizId',
    name: 'quiz',
    component: QuizPage,
    meta: { requiresAuth: true, subtopbar: subtopbarCommon, titleKey: 'feed' }
  },
  {
    path: '/quiz-profiway/:id',
    name: 'quiz-profiway',
    component: QuizProfiwayPage,
    meta: { requiresAuth: true, subtopbar: subtopbarCommon, titleKey: 'feed' }
  },
  {
    path: '/help',
    name: 'help',
    component: HelpPage,
    meta: { requiresAuth: true, subtopbar: subtopbarCommon, titleKey: 'sidebar_help_label' }
  },
  {
    path: '/settings',
    name: 'settings',
    component: SettingsPage,
    meta: { requiresAuth: true, subtopbar: subtopbarCommon, titleKey: 'sidebar_settings_label' }
  },
  {
    path: '/settings/change-lang',
    name: 'settings-change-lang',
    component: SettingsChangeLangPage,
    meta: { requiresAuth: true, subtopbar: subtopbarCommon, titleKey: 'change-lang' }
  },
  {
    path: '/settings/change-password',
    name: 'settings-change-password',
    component: SettingsChangePasswordPage,
    meta: { requiresAuth: true, subtopbar: subtopbarCommon, titleKey: 'change-password' }
  },
  {
    path: '/settings/exit',
    name: 'settings-exit',
    component: SettingsExitPage,
    meta: { requiresAuth: true, subtopbar: subtopbarCommon, titleKey: 'change_user' }
  },
  {
    path: '/schedule',
    name: 'child-schedule',
    component: ChildSchedulePage,
    meta: { requiresAuth: true, subtopbar: subtopbarCommon, titleKey: 'child-schedule' }
  },
  {
    path: '/calendar',
    name: 'calendar',
    component: ChildCalendarPage,
    meta: { requiresAuth: true, subtopbar: subtopbarCommon, titleKey: 'calendar' }
  },
  {
    path: '/grades-rating',
    name: 'child-grades-rating',
    component: ChildGradesRatingPage,
    meta: { requiresAuth: true, subtopbar: subtopbarCommon, titleKey: 'child-grades-rating' }
  },
  {
    path: '/avg',
    name: 'child-avg-help',
    component: ChildAvgHelpPage,
    meta: { requiresAuth: true, subtopbar: subtopbarCommon, titleKey: 'avg_help' }
  },
  {
    path: '/report-card',
    name: 'child-report-card',
    component: ChildReportCardPage,
    meta: { requiresAuth: true, subtopbar: subtopbarCommon, titleKey: 'child-report-card' }
  },
  {
    path: '/all-tasks',
    name: 'all-tasks',
    component: ChildAllTasksPage,
    meta: { requiresAuth: true, subtopbar: subtopbarCommon, titleKey: 'tasks' }
  },
  {
    path: '/task',
    name: 'task',
    component: ChildTaskPage,
    meta: { requiresAuth: true, subtopbar: subtopbarCommon, titleKey: 'tasks' }
  },
  {
    path: '/test',
    name: 'test',
    component: ChildTestPage,
    meta: { requiresAuth: true, subtopbar: subtopbarCommon, titleKey: 'tests' }
  },
  {
    path: '/menu',
    name: 'menu',
    component: ChildMenuPage,
    meta: { requiresAuth: true, subtopbar: subtopbarCommon, titleKey: 'menu' }
  },
  {
    path: '/video-course',
    name: 'video-course',
    component: ChildVideoCoursePage,
    meta: { requiresAuth: true, subtopbar: subtopbarCommon, titleKey: 'video-course' }
  },
  {
    path: '/career-guide',
    name: 'career-guide',
    component: ChildCareerGuidePage,
    meta: { requiresAuth: true, subtopbar: subtopbarCommon, titleKey: 'career-guide' }
  },
  {
    path: '/sos',
    name: 'sos',
    component: ChildSosPage,
    meta: { requiresAuth: true, subtopbar: subtopbarCommon, titleKey: 'sos' }
  },
  { path: '/', redirect: '/feed' },
  { path: '/:pathMatch(.*)*', name: 'not-found', component: NotFoundPage }
];

const isCordovaBuild = import.meta.env.VITE_APP_PLATFORM === 'cordova';
const protocol = typeof window !== 'undefined' ? window.location.protocol : '';
const isNativeWebViewProtocol = protocol && protocol !== 'http:' && protocol !== 'https:';
const shouldUseHashHistory = isCordovaBuild || isNativeWebViewProtocol;
const cordovaPlatform = import.meta.env.VITE_CORDOVA_PLATFORM;
const shouldUseCordovaNetworkGuard = isCordovaBuild && ['android', 'ios'].includes(cordovaPlatform);
const NO_CONNECTION_ROUTE_NAME = 'no-connection';
const OFFLINE_RETURN_PATH_KEY = 'offlineReturnPath';

const router = createRouter({
  history: shouldUseHashHistory ? createWebHashHistory() : createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 };
  }
});

router.beforeEach((to, from, next) => {
  const viewerStore = useViewerStore();
  viewerStore.initFromStorage();
  const deviceStore = useDeviceStore();

  if (
    shouldUseCordovaNetworkGuard &&
    deviceStore.isCordovaReady &&
    !deviceStore.isOnline &&
    to.name !== NO_CONNECTION_ROUTE_NAME
  ) {
    if (from.name && from.name !== NO_CONNECTION_ROUTE_NAME) {
      sessionStorage.setItem(OFFLINE_RETURN_PATH_KEY, from.fullPath);
    }
    next({ name: NO_CONNECTION_ROUTE_NAME, replace: true });
    return;
  }

  const token = localStorage.getItem('token');

  if (to.meta.requiresAuth && !token) {
    next('/login');
    return;
  }

  if (to.meta.guestOnly && token) {
    next('/feed');
    return;
  }

  next();
});

export default router;
